import { colors } from '@material-ui/core'

const white = '#FFFFFF'
const black = '#000000'

export default {
  black,
  white,
  primary: {
    main: '#3380CC',
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400'],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  // link: colors.blue[800],
  link: '#0000FF',
  button: {
    login: colors.green[600],
    cancel: 'darkgray',
    delete: '#d95e49',
  },
  buttonHover: {
    login: colors.green[900],
    cancel: 'd5d5d5',
    delete: colors.red[900],
  },
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  divider: colors.grey[200],
}
